import logger from '@eventbrite/client-logger';
import { RISK_GATE_STATUS, TlzEnvironment, _getRiskGateUrl } from './constants';

export const getRiskGate = async ({
    env,
    eventId,
    metadata,
}: {
    env: TlzEnvironment;
    eventId: string;
    metadata: Record<string, any>;
}): Promise<{
    body: { status: RISK_GATE_STATUS };
}> => {
    const response = await fetch(_getRiskGateUrl({ env, eventId }), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(metadata),
    });

    const body = await response.json();

    if (body.error) {
        const errorMessage = `RiskGate returned a body describing an error: ${
            body.error
        } (full body: ${JSON.stringify(body)})`;

        logger.error(errorMessage);
        throw new Error(body.error);
    }

    return body;
};
